export default class extends Controller {
  static targets = ["notifyUsersSelect"]

  connect() {
    this.initializeSelect2()
  }

  initializeSelect2() {
    const users = JSON.parse(this.notifyUsersSelectTarget.dataset.users)
    const selectedUsers = JSON.parse(this.notifyUsersSelectTarget.dataset.selected)
    const placeholder = this.notifyUsersSelectTarget.dataset.placeholder

    $(this.notifyUsersSelectTarget).select2({
      placeholder: placeholder,
      width: '100%',
      multiple: true,
      data: users,
      initSelection: (element, callback) => {
        const selected = users.filter(user => selectedUsers.includes(user.id))
        callback(selected)
      }
    }).select2('val', selectedUsers)
  }

  addAllProjectRoles(event) {
    event.preventDefault()
    const $select = $(this.notifyUsersSelectTarget)
    const allUsers = JSON.parse(this.notifyUsersSelectTarget.dataset.users)
    const selectedUsers = JSON.parse(this.notifyUsersSelectTarget.dataset.selected)
    $select.select2('data', allUsers.filter(user => selectedUsers.includes(user.id)))
  }

  clearAllUsers(event) {
    event.preventDefault()
    $(this.notifyUsersSelectTarget).select2('data', null).trigger('change')
  }

  disconnect() {
    $(this.notifyUsersSelectTarget).select2('destroy')
  }
}


// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/blocked-task-notifications-controller.js